import { ColourPickerField } from "@/components/UI/ColourPicker";
import { NoxusInputField } from "../InputField";
import { Control, FieldErrors, useWatch } from "react-hook-form";
import { FormEventHandler } from "react";

export const GroupForm = ({
  control,
  errors,
  handleSubmit,
}: {
  control: Control<any>;
  errors: FieldErrors<any>;
  handleSubmit: FormEventHandler<HTMLFormElement>;
}) => {
  const nameValue = useWatch({ control, name: "name" }) as string | undefined;

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-6 items-start">
        <NoxusInputField
          rules={{
            required: { value: true, message: "Field is required" },
            maxLength: {
              value: 64,
              message: "Name cannot be longer than 64 characters.",
            },
          }}
          errors={errors}
          name="name"
          label="Workspace name"
          placeholder="Name"
          control={control}
        />
        <NoxusInputField
          name="description"
          label="Workspace description"
          control={control}
          helperText="Describe the purpose of this workspace. Workspaces can usually represent a department, project or topic."
          placeholder="Description"
          isTextarea
          isResizable={false}
          customStyle="h-[6rem]"
        />
        <ColourPickerField
          name="color"
          label="Color"
          surface="workspace"
          control={control}
          initialsSource={nameValue}
        />
      </div>
    </form>
  );
};
